// extracted by mini-css-extract-plugin
module.exports = {"filterWrap":"List_filterWrap_lPxLi","tableWrap":"List_tableWrap_3VZ7B"};